import {
  Button,
  ButtonProps,
  cn,
  Dropdown,
  DropdownContent,
  DropdownContentProps,
  DropdownProps,
  DropdownTrigger,
  RiArrowDownSLine,
} from '@landler/component-library';
import { createContext, useContext, useState } from 'react';

import { isNullish } from '@/utils/booleans';

const PickerContext = createContext<{ open: boolean; setOpen: (open: boolean) => void }>({
  open: false,
  setOpen: () => undefined,
});

export const usePicker = () => useContext(PickerContext);

export const Picker = ({ open: openProp, onOpenChange, modal = false, ...delegated }: DropdownProps) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <PickerContext.Provider value={{ open, setOpen }}>
      <Dropdown
        modal={modal}
        open={openProp ?? open}
        onOpenChange={(newOpenState) => {
          onOpenChange?.(newOpenState);

          if (isNullish(openProp)) {
            setOpen(newOpenState);
          }
        }}
        {...delegated}
      />
    </PickerContext.Provider>
  );
};

export const PickerTrigger = ({ className, ...delegated }: ButtonProps) => {
  return (
    <DropdownTrigger asChild>
      <Button
        variant='contained'
        color='white'
        size='small'
        rightAdornment={<RiArrowDownSLine className='group-data-[state=open]/trigger:rotate-180' />}
        className={cn('group/trigger tabular-nums', className)}
        {...delegated}
      />
    </DropdownTrigger>
  );
};

export const PickerContent = ({ className, ...delegated }: DropdownContentProps) => {
  return (
    <DropdownContent className={cn('rounded-[20px] p-4', className)} sideOffset={8} align='start' {...delegated} />
  );
};
